import React from 'react';
import { MessageCircle, Truck, MapPin } from 'lucide-react';

const LocalService = () => {
  return (
    <section className="py-24 bg-[#FEFCF8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* First Block */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Image */}
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1589923188651-268a9765e432?w=800&auto=format&fit=crop&q=80"
              alt="Person working on a farm"
              className="w-full h-[450px] object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -left-6 w-full h-full border-4 border-[#2D5016] rounded-2xl -z-10" />
          </div>

          {/* Content */}
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-[#D4A84B]/20 text-[#A0522D] text-xs font-semibold uppercase tracking-wider mb-4">
              Personal Touch
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3B2F1E] mb-4 leading-tight">
              Local Service & Personal Support
            </h2>
            <p className="text-[#3B2F1E]/70 text-lg mb-8">
              At Good Grains, you talk to real experienced people who know animals and farms.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#2D5016]/10 flex items-center justify-center flex-shrink-0">
                  <MessageCircle className="w-6 h-6 text-[#2D5016]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#3B2F1E] mb-1">Friendly guidance</h3>
                  <p className="text-[#3B2F1E]/70">Get personalized advice tailored to your animals' needs.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#2D5016]/10 flex items-center justify-center flex-shrink-0">
                  <Truck className="w-6 h-6 text-[#2D5016]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#3B2F1E] mb-1">Local delivery drop-offs</h3>
                  <p className="text-[#3B2F1E]/70">Around Kalispell, Montana and nearby areas. Convenient, reliable delivery right to your farm.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#2D5016]/10 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-[#2D5016]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#3B2F1E] mb-1">Simple pickup</h3>
                  <p className="text-[#3B2F1E]/70">1185 Majestic View Lane, Kalispell, Montana 59901</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Second Block - Reversed */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <span className="inline-block px-3 py-1 rounded-full bg-[#D4A84B]/20 text-[#A0522D] text-xs font-semibold uppercase tracking-wider mb-4">
              Trusted Partner
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3B2F1E] mb-4 leading-tight">
              Your Local Feed Supplier You Can Trust
            </h2>
            <p className="text-[#3B2F1E]/70 text-lg mb-8">
              We know feeding animals is daily work. That's why we focus on making it simple and dependable.
            </p>

            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-[#D4A84B]" />
                <span className="text-[#3B2F1E]/80">Locally owned and operated in Kalispell, Montana</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-[#D4A84B]" />
                <span className="text-[#3B2F1E]/80">Local delivery drop-offs around Kalispell, Montana and nearby areas</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-[#D4A84B]" />
                <span className="text-[#3B2F1E]/80">Simple pickup from our location (1185 Majestic View Lane, Kalispell, Montana 59901)</span>
              </li>
            </ul>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative">
            <img
              src="https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800&auto=format&fit=crop&q=80"
              alt="Montana mountain landscape with farmland"
              className="w-full h-[450px] object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-[#D4A84B] rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalService;
